import React from 'react';
import { Link, IndexLink } from 'react-router';
import axios from '../../../../constants/axios.js';

class SaleReceivePayment extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         billInfo: {},
         paymentAccounts: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`inventorySales/billInformation/${invoiceId}`)
         .then((res) => {
            this.setState({
               billInfo: res.data
            });
         });
   }


   render() {
      const { invoiceId } = this.props.params;
      const { billInfo } = this.state;
      return (
         <div>
            <div>
               <p>Bill id: {billInfo.id}</p>
               <p>Contact Name: {billInfo.contact_name}</p>
               <p>Bill Amount: {billInfo.amount}</p>
               <p>Bill Due: {billInfo.amount_due}</p>
            </div>
            <hr/>
            <div>
               <ul className="nav nav-tabs" >
                  <li>
                     <IndexLink to={`/sale/saleReceivePayment/${invoiceId}`}
                                activeStyle={{ color: 'red' }} >Full Payment</IndexLink>
                  </li>
                  <li>
                     <Link to={`/sale/saleReceivePayment/${invoiceId}/partialPayment`}
                           activeStyle={{ color: 'red' }} >Partial Payment
                     </Link>
                  </li>
               </ul>
            </div>
            {this.props.children}
         </div>
      );
   }
}

SaleReceivePayment.propTypes = {
   params: React.PropTypes.object,
   children: React.PropTypes.object
};

export default SaleReceivePayment;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleReceivePayment/SaleReceivePayment.js
 **/